import { styled } from '@mui/material';
import type { ReactNode } from 'react';

import { DOCUMENT_LIST_CONTAINER } from './documentListContainer';

type Props = {
  children: ReactNode;
  'aria-label': string;
  'aria-busy'?: boolean;
  'data-testid'?: string;
};

const List = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  containerType: 'inline-size',
  containerName: DOCUMENT_LIST_CONTAINER,
  '& > li + li': {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

/**
 * Library of `DocumentListItem` rows separated by hairline dividers.
 * Rows stack on narrow widths and switch to aligned columns once the list itself is wide enough
 * (container query, not viewport).
 */
export function DocumentList(props: Props) {
  return (
    <List
      aria-label={props['aria-label']}
      aria-busy={props['aria-busy']}
      data-testid={props['data-testid'] ?? 'document-list'}
    >
      {props.children}
    </List>
  );
}

export type { Props as DocumentListProps };
